import { questionType } from '../../lib/types'
import PropTypes from 'prop-types'

const Interstitial = ({ step, goToStep, getIndex, children }) => {
  return (
    <div className="flex flex-col items-center mt-10 text-center">
      <h1 className="mt-10 headline-lg">{step?.title}</h1>

      <div
        className="mb-10 text-gray-500 prose prose-lg md:prose-2xl"
        dangerouslySetInnerHTML={{ __html: step?.description }}
      />

      <div className="flex gap-6 md:gap-4 shrink-0">
        {step?.backTo && (
          <button
            className="w-36 btn btn--outline-secondary"
            onClick={() => {
              goToStep(getIndex(step.backTo))
            }}
          >
            Back
          </button>
        )}

        {step?.nextTo && (
          <button
            className="w-36 w-full btn btn--secondary"
            onClick={() => {
              goToStep(getIndex(step.nextTo))
            }}
          >
            Next
          </button>
        )}
      </div>

      {children}
    </div>
  )
}

Interstitial.propTypes = {
  step: questionType.isRequired,
  goToStep: PropTypes.func.isRequired,
  getIndex: PropTypes.func.isRequired,
  children: PropTypes.element,
}

export default Interstitial
